import React from 'react';
import { cn } from '../utils/classNames';

interface Props {
  icon: React.ReactNode;
  title: string | React.ReactNode;
  content?: React.ReactNode;
  slim?: boolean;
}

export const PageHeader: React.FC<Props> = ({ icon, title, content, slim }) => {
  return (
    <header
      className={cn(
        'mb-1 flex w-full items-center gap-8 px-12',
        slim ? 'h-[90px] min-h-[90px]' : 'h-[140px] min-h-[140px]',
      )}
    >
      {icon ? <div className="[&>svg]:size-[40px]">{icon}</div> : null}
      <h2 className="text-[48px]">{title}</h2>
      {content && <aside className="grow">{content}</aside>}
    </header>
  );
};
